var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16245_9981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 3.79746C19.2642 4.12412 18.4733 4.34412 17.6433 4.44329C18.4908 3.93579 19.1417 3.13162 19.4475 2.17329C18.655 2.64329 17.7767 2.98496 16.8417 3.16912C16.0942 2.37162 15.0267 1.87329 13.8467 1.87329C11.1975 1.87329 9.25083 4.34496 9.84917 6.91079C6.44 6.73996 3.41667 5.10662 1.3925 2.62412C0.3175 4.46829 0.835 6.88079 2.66167 8.10246C1.99 8.08079 1.35667 7.89662 0.804167 7.58912C0.759167 9.48996 2.12167 11.2683 4.095 11.6641C3.5175 11.8208 2.885 11.8575 2.24167 11.7341C2.76333 13.3641 4.27833 14.55 6.075 14.5833C4.35 15.9358 2.17667 16.54 0 16.2833C1.81583 17.4475 3.97333 18.1266 6.29 18.1266C13.9083 18.1266 18.2125 11.6925 17.9525 5.92162C18.7542 5.34246 19.45 4.61996 20 3.79746Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16245_9981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon_twitter.10fab5e524a6df92696a663782b5aa20.svg";
export { ForwardRef as ReactComponent };